import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function PageShell({
  title,
  subtitle,
  description,
  icon,
  actions,
  className,
  children,
}: {
  title: string;
  subtitle?: string;
  description?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  const resolvedSubtitle = subtitle ?? description;

  return (
    <div
      className={cn(
        "v2-motion-page-enter mx-auto w-full max-w-7xl p-4 md:p-6 lg:p-8",
        className
      )}
    >
      <header className="mb-6 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="v2-text-heading flex items-center gap-3 text-2xl font-extrabold tracking-tight">
            {icon ? (
              <span className="shrink-0 text-[var(--v2-text-muted)]">
                {icon}
              </span>
            ) : null}
            {title}
          </h1>
          {resolvedSubtitle ? (
            <p className="v2-text-body mt-2 text-sm">{resolvedSubtitle}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex items-center gap-2">{actions}</div>
        ) : null}
      </header>
      {children}
    </div>
  );
}
